export default "__VITE_ASSET__cfb2b588__"